import React, { useState, useEffect } from "react";
import CalendarCardSection, { Dots } from "../common/CalendarCard";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

const getAllPages = (pages) => {
  const allBusinessPages = pages.featuredList["promote your business"];
  const allCustomersPages = pages.featuredList["get more customers"];
  const allBrandsPages = pages.featuredList["build your brand"];
  const allBookingPages = pages.featuredList["personalize online booking"];
  const allProductivityPages = pages.featuredList["increase productivity"];
  const allPages = {
    allBusinessPages,
    allCustomersPages,
    allBrandsPages,
    allBookingPages,
    allProductivityPages,
  };
  return pages.featuredList;
};

const PagesList = ({ data, tab, wrapClassName }) => {
  let pagesForSelectedLanguage = "";
  if (tab === "all topics") {
    pagesForSelectedLanguage = getAllPages(data);
  } else {
    pagesForSelectedLanguage = data["featuredList"][tab.toLowerCase()];
  }
  const IntegrationsList = ({ id, order, data, classes }) => {
    const Lists = ({ data, cols }) => {
      return <CalendarCardSection data={data} lineCount={5} />;
    };
    return (
      <article id={id} className={`container ${classes}`}>
        <h2
          className="heading"
          dangerouslySetInnerHTML={{
            __html: data.heading,
          }}
        />
        <div className="lists-container">
          <div className="list-section cards fx" id={`cardContainer-${order}`}>
            <Lists data={data.lists} cols={data.columnCount} />
          </div>
        </div>
        {Dots(data.lists, order)}
        <style jsx global>{`
          .cards {
            position: relative;
            flex-wrap: wrap;
            gap: 40px;
            max-height: 1725px;
          }
        `}</style>
      </article>
    );
  };
  const AllIntegrationList = () => {
    const pagesArray = [
      {
        id: "business",
        page: "promote your business",
      },
      {
        id: "customer",
        page: "get more customers",
      },
      {
        id: "brand",
        page: "build your brand",
      },
      {
        id: "booking",
        page: "personalize online booking",
      },
      {
        id: "productivity",
        page: "increase productivity",
      },
    ];
    return (
      <>
        {pagesArray.map((data, index) => (
          <IntegrationsList
            key={index}
            id={data.id}
            order={index + 1}
            data={pagesForSelectedLanguage[data.page]}
            classes="lg:pt-20 md:pt-3"
          />
        ))}
      </>
    );
  };

  return (
    <section
      className={`${wrapClassName} bg-light-blue-grey lg:pt-6 lg:-mb-4`}
      id="default-container"
    >
      {tab === "all topics" ? (
        <AllIntegrationList />
      ) : (
        <>
          <IntegrationsList
            data={pagesForSelectedLanguage}
            classes="active-section lg:pt-20 lg:pb-20"
          />
        </>
      )}
      <style global jsx>
        {`
          #default-container {
            margin-top: -100px !important;
          }
          @media (max-width: ${viewport.tablet.sm}) {
            #default-container {
              margin-top: -60px !important;
              margin-bottom: -120px !important;
            }
        `}
      </style>
    </section>
  );
};

export default PagesList;
